import { Step } from '@HomaHealth/ui-component-library/lib/_AIQ-components/organisms/AnnualStepper';
export interface ChecklistItem {
  id: string;
  title: string;
  notes?: string[];
  documents?: any[];
  completed?: boolean;
  isBookmarked?: boolean;
}

export interface CheckoffList {
  _id: string;
  eg_nid: string;
  renewal_id: string;
  name: string;
  notes?: string[];
  is_marked_completed?: boolean;
  is_bookmarked?: boolean;
  position?: number;
  createdBy: string;
}

export const formatCheckoffList = (list: CheckoffList[]): ChecklistItem[] => {
  if (!Array.isArray(list)) {
    return [];
  }
  return list?.map((item) => ({
    id: item._id,
    title: item.name,
    notes: Array.isArray(item.notes)
      ? item.notes.flatMap((note) =>
          note
            .split('\n')
             
            .map((n) => n.trim())
            .filter(Boolean),
        )
      : [],
    completed: item.is_marked_completed || false,
    isBookmarked: item.is_bookmarked || false,
  }));
};

export const updateStepStatuses = (
  steps: Step[],
  currentStepTitle: string | null,
): Step[] => {
  if (!currentStepTitle) {
    return steps.map((step, index) => ({
      ...step,
      status: index === 0 ? 'active' : 'upcoming',
    }));
  }

  const activeStepIndex = steps.findIndex(
    (step) => step.title === currentStepTitle,
  );

  if (activeStepIndex === -1) {
    return steps.map((step, index) => ({
      ...step,
      status: index === 0 ? 'active' : 'upcoming',
    }));
  }

  return steps.map((step, index) => {
    if (index < activeStepIndex) {
      return { ...step, status: 'completed' };
    } else if (index === activeStepIndex) {
      return { ...step, status: 'active' };
    } else {
      return { ...step, status: 'upcoming' };
    }
  });
};
